/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ConfirmPaymentIntentRequest = {
    paymentIntentId?: string;
    paymentMethodType?: ConfirmPaymentIntentRequest.paymentMethodType;
};
export namespace ConfirmPaymentIntentRequest {
    export enum paymentMethodType {
        PAYPAL = 'paypal',
        CUSTOMER_BALANCE = 'customer_balance',
    }
}

